<div *ngIf="(!isAvailableDocuments && !isJobMatchFolders)
        || (!isAvailableDocuments && isJobMatchFolders && folder.showParentFolder)
        || (isAvailableDocuments && (folder.showParentFolder || folder.showChildFolder))"
    class="tree-node tree-node-content tree-node-content-custom-class position-relative mr-3"
    (click)="onFolderClick()"
    [ngClass]="{'active-folder': folder.active, 'active-available-documents-folder': folder.selected}"
    (mouseover)="folder.showActions = true"
    (mouseleave)="folder.showActions = false">
    <div class="d-flex flex-nowrap align-items-center text-overflow-ellipsis">
        <input *ngIf="isAvailableDocuments" class="mr-3 mt-0 ml-2 position-relative cursor-pointer" style="top: 1px" type="checkbox" id="file-{{folder.id}}"
            [(ngModel)]="folder.selected" (change)="selectFolderWithDocuments.emit(folder)"/>
        <a *ngIf="folder.folders && folder.folders.length" class="pr-2 position-relative" style="color: gray; top: -1px" (click)="toggle()">
            <span class="fas pr-2" style="font-size: 12px"
                [ngClass]="collapsed ? 'fa-chevron-right' : 'fa-chevron-down'"></span>
        </a>
        <img src="assets/app-content/img/folder.svg" alt="" style="height:17px">
        <p class="ml-3 mb-0 text-overflow-ellipsis document-tree-folder-name" tooltip="{{folder.name}}" container="body" [adaptivePosition]="false"> {{folder.name}}</p>
        <div *ngIf="folder.documents && folder.documents.length>0 && !isAvailableDocuments"
            class="position-absolute"
            style="right:25px;"
            tooltip="Total Documents" container="body" [adaptivePosition]="false">
            <i class="far fa-file-alt"></i>
            {{folder.documents.length}}
        </div>
        <div class="dropdown position-absolute" *ngIf="folder.showActions && !isJobMatchFolders && !isAvailableDocuments && folder.id != 'sharedFolder'"
            style="top:10px;right:7px;width:10px; z-index:10">
            <i class="fas fa-ellipsis-v text-muted"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
            </i>
            <ul class="dropdown-menu dropdown-menu-right" role="menu">
                <li role="menuitems" *ngIf="!folder.parentFolderId">
                    <a href="" (click)="$event.preventDefault(); addFolder.emit(folder)" style="height: 30px;line-height: 30px; margin-left: 5px; padding-left: 5px;">
                        Add Sub Folder
                    </a>
                </li>
                <li role="menuitems">
                    <a href="" (click)="$event.preventDefault(); moveFolder.emit(folder)" style="height: 30px;line-height: 30px; margin-left: 5px; padding-left: 5px;">
                        Move folder
                    </a>
                </li>
                <li role="menuitems">
                    <a href="" (click)="$event.preventDefault(); editFolder.emit(folder)" style="height: 30px;line-height: 30px; margin-left: 5px; padding-left: 5px;">
                        Edit
                    </a>
                </li>
                <li role="menuitems">
                    <a href="" (click)="$event.preventDefault(); deleteFolder.emit(folder)" style="height: 30px;line-height: 30px; margin-left: 5px; padding-left: 5px;">
                        Delete
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>
<div *ngIf="folder.documents && folder.documents.length > 0" class="pl-2 py-2" [ngClass]="{hidden: collapsed}">
    <div *ngFor="let document of folder.documents">
        <div class="pl-5 ml-3 pr-4 py-2 d-flex align-items-center flex-nowrap text-muted text-overflow-ellipsis"
            (click)="onDocumentClick(document)">
            <div class="mr-3" *ngIf="isAvailableDocuments">
                <input class="cursor-pointer" type="checkbox" id="file-{{document.id}}"
                    [(ngModel)]="document.selected" (change)="selectAndDeselectDocument.emit({document: document, folder: folder})"/>
            </div>
            <div class="mr-3">
                <span><i class="far fa-file-alt"></i></span>
            </div>
            <div class="text-overflow-ellipsis cursor-pointer">
                <div class="text-overflow-ellipsis">{{document.fileName}}</div>
            </div>
        </div>
    </div>
</div>
<ul class="list-unstyled ml-5" *ngIf="folder.folders && folder.folders.length" [ngClass]="{hidden: collapsed}">
    <li class="my-1" *ngFor="let childFolder of folder.folders" [hidden]="!visible(childFolder)">
        <app-documents-tree-node
            [folder]="childFolder"
            [isJobMatchFolders]="isJobMatchFolders"
            [isAvailableDocuments]="isAvailableDocuments"
            [query]="query"
            (selectFolder)="selectFolder.emit($event)"
            (addFolder)="addFolder.emit($event)"
            (editFolder)="editFolder.emit($event)"
            (deleteFolder)="deleteFolder.emit($event)"
            (moveFolder)="moveFolder.emit($event)"
            (selectFolderWithDocuments)="selectFolderWithDocuments.emit($event)"
            (selectAndDeselectDocument)="selectAndDeselectDocument.emit($event)"
            (documentSelect)="documentSelect.emit($event)">
        </app-documents-tree-node>
    </li>
</ul>
